import useSeo from "@/hooks/useSeo";
import PageHeader from "@/components/feature/PageHeader";
import Reveal from "@/components/base/Reveal";
import ContactForm from "@/pages/contact/components/ContactForm";
import { site } from "@/mocks/site";

const contactJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "联系我们",
    url: "https://law818.cn/contact",
    inLanguage: "zh-CN",
    description: "联系 513吃瓜编辑团队，进行热梗推荐、二创投稿、内容纠错或商务合作。",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "513吃瓜",
    url: "https://law818.cn/",
    email: site.email,
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: site.email,
      availableLanguage: ["zh-CN"],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://law818.cn/" },
      { "@type": "ListItem", position: 2, name: "联系我们", item: "https://law818.cn/contact" },
    ],
  },
];

const channels = [
  {
    icon: "ri-mail-line",
    label: "合作与投稿邮箱",
    value: site.email,
    desc: "适合发送带有链接或附件的正式投稿。",
  },
  {
    icon: "ri-wechat-line",
    label: "官方微信",
    value: site.wechat,
    desc: "添加时请备注来意，便于我们快速对接。",
  },
  {
    icon: "ri-time-line",
    label: "回复时间",
    value: site.workingHours,
    desc: "留言通常会在 1-2 个工作日内得到回复。",
  },
];

const tips = [
  "推荐一个梗时，附上你第一次看到它的时间和平台，能帮我们更快溯源。",
  "投稿二创作品请一并说明使用的原始素材出处，方便我们标注授权信息。",
  "发现内容有误时，直接指出具体段落和问题即可，我们会尽快核实修改。",
];

export default function Contact() {
  useSeo({
    title: "联系我们 | 投稿、纠错与合作 - 513吃瓜",
    description:
      "联系 513吃瓜编辑团队：推荐网络热梗、投稿二创二改与表情包作品、反馈内容错误或洽谈内容合作，均可通过这里的表单与我们取得联系。",
    keywords: "513吃瓜联系我们,二创投稿,热梗推荐,内容纠错,内容合作",
    path: "/contact",
    jsonLd: contactJsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="我们在听"
        title="联系我们"
        desc="不管是推荐一个梗、投稿自己的二创，还是指出我们写错的地方，都欢迎直接说。每一条留言都会有人认真看完。"
        crumbs={[{ label: "首页", path: "/" }, { label: "联系我们" }]}
      />

      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-14 md:px-6 md:py-16 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)]">
        <Reveal>
          <ContactForm />
        </Reveal>

        <div className="space-y-5">
          {channels.map((channel, index) => (
            <Reveal key={channel.label} delay={index * 70}>
              <div className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-background-50 text-xl text-primary-600">
                  <i className={channel.icon} aria-hidden="true"></i>
                </span>
                <div className="min-w-0">
                  <p className="font-label text-xs text-foreground-500">{channel.label}</p>
                  <p className="mt-1 break-words text-base font-medium text-foreground-950">{channel.value}</p>
                  <p className="mt-1 text-sm text-foreground-600">{channel.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal delay={220}>
            <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-6">
              <h2 className="flex items-center gap-2 font-heading text-lg text-secondary-900">
                <i className="ri-information-line" aria-hidden="true"></i>
                留言小贴士
              </h2>
              <ul className="mt-4 space-y-3">
                {tips.map((tip) => (
                  <li key={tip} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-700">
                    <span className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-[10px] text-background-50">
                      <i className="ri-check-line" aria-hidden="true"></i>
                    </span>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </>
  );
}